var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 5.74414C18.6046 5.74414 19.5 6.63957 19.5 7.74414C19.5 8.84871 18.6046 9.74414 17.5 9.74414C16.3954 9.74414 15.5 8.84871 15.5 7.74414C15.5 6.63957 16.3954 5.74414 17.5 5.74414Z",
    fill: "#0C4654"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 10.7441C18.6046 10.7441 19.5 11.6396 19.5 12.7441C19.5 13.8487 18.6046 14.7441 17.5 14.7441C16.3954 14.7441 15.5 13.8487 15.5 12.7441C15.5 11.6396 16.3954 10.7441 17.5 10.7441Z",
    fill: "#0C4654"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 15.7441C18.6046 15.7441 19.5 16.6396 19.5 17.7441C19.5 18.8487 18.6046 19.7441 17.5 19.7441C16.3954 19.7441 15.5 18.8487 15.5 17.7441C15.5 16.6396 16.3954 15.7441 17.5 15.7441Z",
    fill: "#0C4654"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 5.74414C13.6046 5.74414 14.5 6.63957 14.5 7.74414C14.5 8.84871 13.6046 9.74414 12.5 9.74414C11.3954 9.74414 10.5 8.84871 10.5 7.74414C10.5 6.63957 11.3954 5.74414 12.5 5.74414Z",
    fill: "#0C4654"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 10.7441C13.6046 10.7441 14.5 11.6396 14.5 12.7441C14.5 13.8487 13.6046 14.7441 12.5 14.7441C11.3954 14.7441 10.5 13.8487 10.5 12.7441C10.5 11.6396 11.3954 10.7441 12.5 10.7441Z",
    fill: "#0C4654"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 15.7441C13.6046 15.7441 14.5 16.6396 14.5 17.7441C14.5 18.8487 13.6046 19.7441 12.5 19.7441C11.3954 19.7441 10.5 18.8487 10.5 17.7441C10.5 16.6396 11.3954 15.7441 12.5 15.7441Z",
    fill: "#0C4654"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 5.74414C8.60457 5.74414 9.5 6.63957 9.5 7.74414C9.5 8.84871 8.60457 9.74414 7.5 9.74414C6.39543 9.74414 5.5 8.84871 5.5 7.74414C5.5 6.63957 6.39543 5.74414 7.5 5.74414Z",
    fill: "#0C4654"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 10.7441C8.60457 10.7441 9.5 11.6396 9.5 12.7441C9.5 13.8487 8.60457 14.7441 7.5 14.7441C6.39543 14.7441 5.5 13.8487 5.5 12.7441C5.5 11.6396 6.39543 10.7441 7.5 10.7441Z",
    fill: "#0C4654"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 15.7441C8.60457 15.7441 9.5 16.6396 9.5 17.7441C9.5 18.8487 8.60457 19.7441 7.5 19.7441C6.39543 19.7441 5.5 18.8487 5.5 17.7441C5.5 16.6396 6.39543 15.7441 7.5 15.7441Z",
    fill: "#0C4654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.1a41ba431bee524c05d8d2d8b1432764.svg";
export { ForwardRef as ReactComponent };